import { render, staticRenderFns } from "./CurriculumEdit.vue?vue&type=template&id=3bad5e95"
import script from "./CurriculumEdit.vue?vue&type=script&lang=js"
export * from "./CurriculumEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports